import httpsService from 'src/api/httpsService';
import { DefaultHeaderToSystm } from 'src/const';
import { createCreDtTm, createMSGID } from 'src/utils/helper';
import { API_PATH } from '../const/api-urls';
export const UpdateStatusPay = (requestId:string,frSystm:string) => {
    const params = {
        requestId:requestId,
        msgId: createMSGID(frSystm)
    }
    const headers = {
        frSystm:frSystm,
        toSystm:DefaultHeaderToSystm,
        creDtTm:createCreDtTm()
    }
    return httpsService.patch(API_PATH.UPDATE_STATUS_PAY,{},{headers:headers,params:params})
}